import { render, staticRenderFns } from "./PaniereDetails.vue?vue&type=template&id=09593538&scoped=true"
import script from "./PaniereDetails.vue?vue&type=script&lang=js"
export * from "./PaniereDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09593538",
  null
  
)

export default component.exports